
// Angular
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Afidium
import { FormFieldModule } from '../form-field/form-field.module';
import { TextComponent } from "./text.component";
import { FocusIfModule } from 'libraries/ui_toolbox/focus-if.module';
import { BlurIfModule } from 'libraries/directive/blur-If/blur-if.module';
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IconNameToDefinitionModule } from "libraries/pipes/icon-name-to-definition/icon-name-to-definition.module";


@NgModule({
    imports: [
        FormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        //TODO NG UPGRADE NgxErrorsModule
        //NgxErrorsModule,
        MatInputModule,
        MatFormFieldModule,
        FocusIfModule,
        BlurIfModule,
        FontAwesomeModule,
        IconNameToDefinitionModule,
    ],
    exports: [TextComponent],
    declarations: [TextComponent],
})
export class TextModule { }
